export default __webpack_public_path__ + "static/24-d7cfa16a47893222c1a931b570fb5ba4.png";